declare const __BRUNEL_APP_VERSION__: string;
declare const __BRUNEL_BUILD_ID__: string;

export function brunelVersionLabel(): string {
  const version = typeof __BRUNEL_APP_VERSION__ === 'string' && __BRUNEL_APP_VERSION__.trim() !== ''
    ? __BRUNEL_APP_VERSION__.trim()
    : 'dev';
  return `v${version}`;
}

export function brunelBuildId(): string {
  return typeof __BRUNEL_BUILD_ID__ === 'string' && __BRUNEL_BUILD_ID__.trim() !== ''
    ? __BRUNEL_BUILD_ID__.trim()
    : 'dev';
}

/** The build's own version, unprefixed ('dev' outside a build), for places that report it. */
export function brunelAppVersion(): string {
  return brunelVersionLabel().slice(1);
}
